import { Icon } from '@sb1/ffe-icons-react';
import { Link } from 'react-router';
import settings from '@sb1/ffe-icons/icons/open/300/md/settings.svg';
import styles from './settings-link.module.less';

export const SettingsLink = ({ className, to, text, icon = settings }) => {
    return (
        <Link className={[styles.tertiatyLink, className].join(' ')} to={to}>
            <Icon fileUrl={icon} />
            {text}
        </Link>
    );
};
